import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-yard',
  templateUrl: './icon-yard.component.html',
  styleUrls: ['./icon-yard.component.scss']
})
export class IconYardComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
